import { render, staticRenderFns } from "./TabelaAgendas.vue?vue&type=template&id=5de84e05&scoped=true&"
import script from "./TabelaAgendas.vue?vue&type=script&lang=js&"
export * from "./TabelaAgendas.vue?vue&type=script&lang=js&"
import style0 from "./TabelaAgendas.vue?vue&type=style&index=0&id=5de84e05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de84e05",
  null
  
)

export default component.exports